<template>
  <div class="coin_wrapper">
    <p v-if="!useIconsByCoinAmount" class="coin_symbol">C</p>
    <img
      class="coin_img"
      v-if="useIconsByCoinAmount"
      :src="getCoinIconBasedOnCoins(amount)"
    />
    <p class="coin_amount" :style="amountStyle">
      {{ coinAmount }}
      <span v-if="showUnit" class="coin_unit">C</span>
    </p>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import Formatter from '@/utils/Formatter'

@Component({})
export default class CoinAmount extends Vue {
  @Prop()
  amount!: number

  @Prop({ default: false })
  showUnit!: boolean

  @Prop({ default: false })
  useIconsByCoinAmount!: boolean

  @Prop()
  amountStyle!: { [k: string]: string } | null

  get coinAmount() {
    return Formatter.numberWithCommas(this.amount)
  }

  getCoinIconBasedOnCoins(coins: number): string {
    switch (true) {
      case coins >= 0 && coins <= 499:
        return '../img/coin_icons_v2/coin_01.png'
      case coins >= 500 && coins <= 999:
        return '../img/coin_icons_v2/coin_02.png'
      case coins >= 1000 && coins <= 2999:
        return '../img/coin_icons_v2/coin_03.png'
      case coins >= 3000 && coins <= 4999:
        return '../img/coin_icons_v2/coin_04.png'
      case coins >= 5000 && coins <= 7999:
        return '../img/coin_icons_v2/coin_05.png'
      case coins >= 8000 && coins <= 9999:
        return '../img/coin_icons_v2/coin_06.png'
      case coins >= 10000 && coins <= 24999:
        return '../img/coin_icons_v2/coin_07.png'
      case coins >= 25000 && coins <= 49999:
        return '../img/coin_icons_v2/coin_08.png'
      case coins >= 50000:
        return '../img/coin_icons_v2/coin_09.png'
      default:
        return '../img/coin_icons_v2/coin_01.png'
    }
  }
}
</script>

<style scoped>
.coin_wrapper {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 20px;
  line-height: 20px;
}

.coin_symbol {
  width: 20px;
  height: 20px;
  color: #ffffff;
  background-color: #ffb91b;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
}

.coin_amount {
  font-size: 14px;
  font-weight: 700;
  margin: 0 4px 0 8px;
  color: #262626;
}
</style>
